import { createApp } from "vue";

import router from "./router.js";
import store from "./store/index.js";
import App from "./App.vue";

import "vuetify/styles";
import { createVuetify } from "vuetify";
import VueMobileDetection from "vue-mobile-detection";
import "@mdi/font/css/materialdesignicons.css";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const vuetify = createVuetify({
  components,
  directives,
});

const app = createApp(App);
app.use(router);
app.use(store);
app.use(vuetify);
app.use(VueMobileDetection);

app.mount("#app");
